import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informasi Umum Sekolah")
], -1)
const _hoisted_6 = { class: "row mb-6" }
const _hoisted_7 = { class: "col-lg-6 fv-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nama Sekolah", -1)
const _hoisted_9 = { class: "col-lg-6 fv-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Initial", -1)
const _hoisted_11 = { class: "row mb-6" }
const _hoisted_12 = { class: "col-lg-6 fv-row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Email", -1)
const _hoisted_14 = { class: "col-lg-6 fv-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nomor Telepon", -1)
const _hoisted_16 = { class: "row mb-6" }
const _hoisted_17 = { class: "col-lg-6 fv-row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Tipe Sekolah", -1)
const _hoisted_19 = {
  key: 0,
  class: "col-lg-6 fv-row"
}
const _hoisted_20 = {
  key: 1,
  class: "col-lg-6 fv-row"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Alamat Sekolah")
], -1)
const _hoisted_22 = { class: "row mb-6" }
const _hoisted_23 = { class: "col-lg-6 fv-row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Provinsi", -1)
const _hoisted_25 = { class: "col-lg-6 fv-row" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Kota/ Kabupaten", -1)
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = { class: "col-lg-6 fv-row" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Kecamatan", -1)
const _hoisted_30 = { class: "col-lg-6 fv-row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Alamat", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informasi Khusus")
], -1)
const _hoisted_33 = { class: "row mb-6" }
const _hoisted_34 = { class: "col-lg-6 fv-row" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Bank", -1)
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "col-lg-6 fv-row" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Area", -1)
const _hoisted_40 = { class: "row mb-6" }
const _hoisted_41 = { class: "col-lg-6 fv-row" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Cabang", -1)
const _hoisted_43 = { class: "col-lg-6 fv-row" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Funding", -1)
const _hoisted_45 = { class: "fv-plugins-message-container" }
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = { class: "row mb-6" }
const _hoisted_48 = { class: "col-lg-6 fv-row" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nomor NPWP", -1)
const _hoisted_50 = { class: "col-lg-6 fv-row" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Tampilan NPWP", -1)
const _hoisted_52 = ["src"]
const _hoisted_53 = { class: "row mb-6" }
const _hoisted_54 = { class: "col-lg-6 fv-row" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Status", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informasi PIC dan Sales")
], -1)
const _hoisted_57 = { class: "row mb-6" }
const _hoisted_58 = { class: "col-lg-6 fv-row" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nama PIC ", -1)
const _hoisted_60 = { class: "col-lg-6 fv-row" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Email PIC", -1)
const _hoisted_62 = { class: "row mb-6" }
const _hoisted_63 = { class: "col-lg-6 fv-row" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nomor Telepon PIC", -1)
const _hoisted_65 = { class: "col-lg-6 fv-row" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Sales Area", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informasi Tambahan")
], -1)
const _hoisted_68 = { class: "row mb-6" }
const _hoisted_69 = { class: "col-lg-6 fv-row" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Tanggal Dibuat", -1)
const _hoisted_71 = { class: "col-lg-6 fv-row" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Dibuat Oleh", -1)
const _hoisted_73 = { class: "row mb-6" }
const _hoisted_74 = { class: "col-lg-6 fv-row" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Catatan", -1)
const _hoisted_76 = { class: "col-lg-6 fv-row" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Target Live", -1)
const _hoisted_78 = { class: "row mb-6" }
const _hoisted_79 = { class: "col-lg-6 fv-row" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Referensi Dari", -1)
const _hoisted_81 = { class: "col-lg-6 fv-row" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "implementator", -1)
const _hoisted_83 = { class: "row mb-6" }
const _hoisted_84 = { class: "col-lg-6 fv-row" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Biaya Top Up", -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Fitur yang digunakan")
], -1)
const _hoisted_87 = { class: "row mb-6" }
const _hoisted_88 = { class: "form-check mb-6" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, " Absensi Wajah ", -1)
const _hoisted_90 = { class: "form-check mb-6" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, " Auto Block Transaksi ", -1)
const _hoisted_92 = { class: "form-check mb-6" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, " Pembayaran Otomatis ", -1)
const _hoisted_94 = { class: "card-footer d-flex justify-content-end py-6 px-9" }

export function render(_ctx: any,_cache: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_Field, {
                type: "text",
                name: "name",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.detail.name) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_Field, {
                type: "text",
                name: "initial",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.initial,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.detail.initial) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_Field, {
                type: "text",
                name: "email",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detail.email) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_Field, {
                type: "text",
                name: "phone",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.phone,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.detail.phone) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_Field, {
                type: "text",
                name: "schoolType",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.schoolType,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.detail.schoolType) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            (_ctx.detail.customApp === 'true')
              ? (_openBlock(), _createElementBlock("div", _hoisted_19))
              : _createCommentVNode("", true),
            (_ctx.detail.customApp === 'false')
              ? (_openBlock(), _createElementBlock("div", _hoisted_20))
              : _createCommentVNode("", true)
          ]),
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode(_component_Field, {
                type: "text",
                class: "form-control form-control-lg",
                name: "province",
                autocomplete: "off",
                modelValue: _ctx.detail.address.province,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.detail.address.province) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_Field, {
                type: "text",
                class: "form-control form-control-lg",
                name: "city",
                autocomplete: "off",
                modelValue: _ctx.detail.address.city,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.detail.address.city) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode(_component_Field, {
                type: "text",
                class: "form-control form-control-lg",
                name: "regency",
                autocomplete: "off",
                modelValue: _ctx.detail.address.regency,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.detail.address.regency) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createVNode(_component_Field, {
                type: "text",
                name: "detail",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.address.detail,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.detail.address.detail) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createVNode(_component_Field, {
                type: "text",
                name: "text",
                class: "form-control form-control-lg",
                modelValue: _ctx.bankName,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.bankName) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_ErrorMessage, { name: "bankData" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createVNode(_component_Field, {
                type: "text",
                name: "text",
                class: "form-control form-control-lg",
                modelValue: _ctx.areaName,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.areaName) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createVNode(_component_Field, {
                type: "text",
                name: "text",
                class: "form-control form-control-lg",
                modelValue: _ctx.branchName,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.branchName) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createVNode(_component_Field, {
                type: "text",
                name: "fundingName",
                class: "form-control form-control-lg",
                placeholder: "Isi Nama Funding",
                modelValue: _ctx.detail.fundingName,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.detail.fundingName) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createVNode(_component_ErrorMessage, { name: "fundingId" })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _hoisted_49,
              _createVNode(_component_Field, {
                type: "number",
                name: "number",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.npwp.number,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.detail.npwp.number) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createElementVNode("img", {
                alt: "",
                class: "img-fluid",
                src: _ctx.url
              }, null, 8, _hoisted_52)
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _hoisted_55,
              _createVNode(_component_Field, {
                type: "text",
                name: "status",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.status,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.detail.status) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _hoisted_56,
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _hoisted_59,
              _createVNode(_component_Field, {
                type: "text",
                name: "picName",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.picName,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.detail.picName) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _hoisted_61,
              _createVNode(_component_Field, {
                type: "text",
                name: "picEmail",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.picEmail,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.detail.picEmail) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _hoisted_64,
              _createVNode(_component_Field, {
                type: "number",
                name: "picPhone",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.picPhone,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.detail.picPhone) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_65, [
              _hoisted_66,
              _createVNode(_component_Field, {
                type: "text",
                name: "salesArea",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.salesArea,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.detail.salesArea) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _hoisted_67,
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _hoisted_70,
              _createVNode(_component_Field, {
                type: "createTime",
                name: "createTime",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.createTime,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.detail.createTime) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_71, [
              _hoisted_72,
              _createVNode(_component_Field, {
                type: "text",
                name: "creatorName",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.creatorName,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.detail.creatorName) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _hoisted_75,
              _createVNode(_component_Field, {
                type: "text",
                name: "note",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.note,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.detail.note) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_76, [
              _hoisted_77,
              _createVNode(_component_Field, {
                type: "date",
                name: "targetLive",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.targetLive,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.detail.targetLive) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _hoisted_80,
              _createVNode(_component_Field, {
                type: "text",
                name: "referenceFrom",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.referenceFrom,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.detail.referenceFrom) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_81, [
              _hoisted_82,
              _createVNode(_component_Field, {
                type: "text",
                name: "implementatorData",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.implementatorData,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.detail.implementatorData) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("div", _hoisted_84, [
              _hoisted_85,
              _createVNode(_component_Field, {
                type: "number",
                name: "topupFee",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.topupFee,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.detail.topupFee) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _hoisted_86,
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.detail.faceRecognition) = $event)),
                disabled: ""
              }, null, 512), [
                [_vModelCheckbox, _ctx.detail.faceRecognition]
              ]),
              _hoisted_89
            ]),
            _createElementVNode("div", _hoisted_90, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.detail.blockCardTransaction) = $event)),
                disabled: ""
              }, null, 512), [
                [_vModelCheckbox, _ctx.detail.blockCardTransaction]
              ]),
              _hoisted_91
            ]),
            _createElementVNode("div", _hoisted_92, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.detail.automaticPayment) = $event)),
                disabled: ""
              }, null, 512), [
                [_vModelCheckbox, _ctx.detail.automaticPayment]
              ]),
              _hoisted_93
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_94, [
        _createElementVNode("button", {
          class: "btn btn-primary me-3",
          onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.$router.push('/superadmin/sekolah')))
        }, " Kembali ")
      ])
    ])
  ], 64))
}